var _style, _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgDashboard",
    x: "0px",
    y: "0px",
    width: "18px",
    height: "18px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.svgDashboard{fill:#B5B5B5;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    className: "svgDashboard svgBase svgHover svgSelect",
    d: "M9.4,9.3c-0.1,0-0.3,0-0.4-0.1C8.8,9,8.8,8.7,9,8.5c0,0,0,0,0,0l3.1-3.1c0.2-0.2,0.5-0.2,0.7,0 s0.2,0.5,0,0.7l-3,3C9.7,9.2,9.6,9.3,9.4,9.3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    className: "svgDashboard svgBase svgHover svgSelect",
    d: "M9,0.8C4.5,0.8,0.8,4.5,0.8,9s3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2l0,0C17.1,4.5,13.5,0.9,9,0.8z  M9,16.1c-3.9,0-7.1-3.1-7.1-7.1c0,0,0-0.1,0-0.1c0-3.9,3.1-7.1,7.1-7.1c0,0,0.1,0,0.1,0c3.9,0,7.1,3.1,7.1,7.1c0,0,0,0.1,0,0.1 C16.2,12.9,13,16.1,9,16.1C9.1,16.1,9,16.1,9,16.1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/dashboard.d5b57fa1.svg";
export { ForwardRef as ReactComponent };